__turbopack_context__.v({
  "content": "IrzfZq_content",
  "list": "IrzfZq_list",
  "menuLink": "IrzfZq_menuLink",
  "menuLinkActive": "IrzfZq_menuLinkActive",
  "trigger": "IrzfZq_trigger",
});
